import useLoggedInUser from 'app/hooks/useLoggedInUser';

import useModalDismissedState from './useModalDismissedState';

/**
 * Like `useModalDismissedState`, but remembered per user, so that on a shared browser (pharmacy
 * PCs, support switching accounts) one person dismissing something doesn't hide it from the others.
 */
export default function useUserDismissedState(storageKey: string): {
  showOnboarding: boolean;
  dismiss: () => void;
} {
  const userId = useLoggedInUser()?._id ?? 'guest';

  return useModalDismissedState(`${storageKey}-${userId}`);
}
